import React from "react";
import useScheduleDay from "../../hooks/useScheduleDay";
import DaySchedule from "./DaySchedule";

const DayScheduleContainer = props => {

    let scheduleDay = useScheduleDay(props.day);

    return (
        <div>
            <h3 className="cts-schedule-day">
                {scheduleDay}
            </h3>
            <div>
                <DaySchedule 
                    notAvailableMsg={props.notAvailableMsg}
                    key={props.day} 
                    day={scheduleDay}
                    times={props.schedules} 
                    disabled={props.disabled} 
                    location={props.location} 
                    onClick={props.onClick} 
                    selectedSchedule={props.selectedSchedule} 
                />
            </div>
        </div>
    )
}

export default DayScheduleContainer;
